const styles = () => ({
  root: {
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 21,
    background: '#FAFBFC',
    justifyContent: 'space-between',
  },

  profile: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '33px 60px 0 35px',
  },

  details: {
    marginLeft: 17,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  companyLogoLink: {
    marginLeft: 'auto',
  },

  companyLogo: {
    maxHeight: 48,
  },

  name: {
    fontWeight: 'normal',
    fontSize: '20px',
    color: '#414953',
    margin: 0,
  },

  email: {
    fontWeight: 'normal',
    fontSize: '15px',
    color: '#A9B0B8',
    margin: 0,
  },

  spacer: {
    flex: '1 1 auto',
  },

  actions: {
    flex: 'none',
  },

  action: {
    '&:not(:last-child)': {
      marginRight: 10,
    },
  },
});

export default styles;
